// import React, { useState, useEffect } from 'react'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom/dist';
import AddSocialMedia from '../../core/modals/inventory/addsocialmedia';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable'
import { PlusCircle  } from 'feather-icons-react/build/IconComponents';
import withReactContent from 'sweetalert2-react-content';
import {set_gateway_list, set_gateway_edit, set_page_refresh} from "../../core/redux/action";
import axios from 'axios';

const SocialMedia = () => {
    const dispatch = useDispatch();
     //social media new block code
    //  const [connectedAccounts, setConnectedAccounts] = useState({});
     //End social media new block code
     
    const pageRefresh = useSelector((state) => (state.pageRefresh?.paymentConfigs || 0));
    // const [dataStore, setDataStore] = useState([]);
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    // const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        async function fetchData() {
          let result = await axios.get("getsocialmedia/");
          dispatch(set_gateway_list(result.data.socialMedias))
        }
        //  if (!isFetching) {
        //     getStoreApi();
        //   }

        fetchData()
        
      }, [pageRefresh])
      
    //social media new block code

    // useEffect(() => {
    //     axios.get('/api/socialmedia/accounts')
    //         .then(response => setConnectedAccounts(response.data))
    //         .catch(error => console.error('Error fetching accounts:', error));
    // }, []);
    //end social media new block code
    const dataSource = useSelector((state) => state.gateway_list);
    const permissions = useSelector(state => state.permissions) || [];
    const roleTitle = useSelector(state => state.roleTitle) || '';
    const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

    const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'view');
    const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'create');
    const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'update');
    const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'delete');

    if (!canView) {
        return ( 
        <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
    )}

    const columns = [
        {
            title: t?.[l]?.["store_name"] || "Store Name",
            dataIndex: "stores",
            render: (stores) => stores?.map(store => store.storeName).join(", "),
        },

        {
            title: t?.[l]?.["social_media_type"] || "Social Media Type",
            dataIndex: "socialMediaDetails",
            render: (socialMediaDetails) => {
                if (!Array.isArray(socialMediaDetails)) {
                    return t?.[l]?.["no_social_media_details"] || "No Social Media Details";
                }
                return socialMediaDetails
                    .map(social => t?.[l]?.[social.socialMediaType] || social.socialMediaType)
                    .join(", ");
            },
        },

        {
            title: t?.[l]?.["action"] || 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                    {canUpdate && (
                        <Link className="me-2 p-2" to="#" data-bs-toggle="modal" data-bs-target="#add-brand" onClick={() => {editBrand(record)}}>
                            <i data-feather="edit" className="feather-edit"></i>
                        </Link>
                        )}
                            {canDelete && (
           
                <Link className="me-2 p-2" to="#"
                onClick={(e) => {
                 e.preventDefault(); // Prevent the default anchor behavior
                 showConfirmationAlert(record);
               }}>
                <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
                   
                        )}
               
               
                    </div>
                </td>
            )
        },
    ]
    const MySwal = withReactContent(Swal);

    const editBrand = async (record) => {
        dispatch(set_gateway_edit(null))    
        setTimeout(() => {
            dispatch(set_gateway_edit(record)); // Set the new state
        }, 0); // Ensure React recognizes the state change
    }
    const showConfirmationAlert = (record) => {
        MySwal.fire({
            title: t?.[l]?.["are_you_sure?"] || "Are you sure?",
            text: t?.[l]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
            showCancelButton: true,
            confirmButtonColor: "#00ff00",
            confirmButtonText: t?.[l]?.["yes,_delete_it!"] || "Yes, delete it!",
            cancelButtonColor: "#ff0000",
            cancelButtonText: t?.[l]?.["cancel"] || "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                console.log('record._id',record);
                let result = await axios.post("removesocialmedia/", {_id: record._id});
                console.log(result)
                dispatch(set_page_refresh("paymentConfigs"))
                MySwal.fire({
                title: t?.[l]?.["deleted!"] || "Deleted!",
                text: t?.[l]?.["item_has_been_deleted."] || "Item has been deleted.",
                className: "btn btn-success",
                confirmButtonText: t?.[l]?.["ok"] || "OK",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then(() => {
                });
              } catch(e) {
                console.log(e)
                return false;
              }
              
            } else {
              MySwal.close();
            }
        });
    };

    
    return (
        <div>
            <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>{t?.[l]?.["social_media"] || "Social Media"}</h4>
                                <h6>{t?.[l]?.["manage_social_media"] || "Manage Social Media"}</h6>
                            </div>
                        </div>
              
                        {canCreate ? (
                        <div className="page-btn">
                            <Link
                                to="#"
                                className="btn btn-added"
                                data-bs-toggle="modal"
                                data-bs-target="#add-brand"
                                onClick={() => dispatch(set_gateway_edit({}))}
                            >
                                <PlusCircle className="me-2" />
                                {t?.[l]?.["add_social_media"] || "Add Social Media"}
                            </Link>
                        </div>
                          ) : null}
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <Table columns={columns} dataSource={dataSource} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddSocialMedia />
        </div>
    )
}

export default SocialMedia;
   //social media new block code


//    import React, { useState } from 'react';
// import axios from 'axios';

// function SocialMedia() {
//   const [authUrl, setAuthUrl] = useState('');
//   const [accessToken, setAccessToken] = useState('');
//   const [video, setVideo] = useState(null);

//   // Step 1: Get TikTok Authorization URL
//   const getAuthUrl = async () => {
//     const response = await  axios.get("gettiktokurl/");
//     console.log("getAuthUrl",response);
//     setAuthUrl(response.data.message);
//   };

//   // Step 2: Handle TikTok OAuth Callback
//   const getAccessToken = async (code) => {
//     const response = await axios.get(`titokcallback?code=${code}`);
//     console.log("getAccessToken",response)
//     setAccessToken(response.data.accessToken);
//   };

//   // Step 3: Handle Video Upload
//   const uploadVideo = async () => {
//     if (!video || !accessToken) {
//       alert('Please select a video and authenticate first');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('video', video);
//     formData.append('accessToken', accessToken);

//     const response = await axios.post('http://localhost:5000/tiktok/upload', formData);
//     console.log(response.data);
//   };

//   return (
//     <div>
//     <div className="page-wrapper">
//     <div className="content">
//                     <div className="page-header">
    
//       <h1>TikTok Video Uploader</h1>

//       {/* Step 1: Get TikTok Auth URL */}
//       <button onClick={getAuthUrl}>Login with TikTok</button>
//       {authUrl && <a href={authUrl} target="_blank" rel="noopener noreferrer">Authorize TikTok</a>}
//       <a href={authUrl}>Continue with TikTok</a>
//       {/* Step 2: Enter Code (After Authorization) */}
//       <input type="text" placeholder="Enter TikTok Code" onBlur={(e) => getAccessToken(e.target.value)} />

//       {/* Step 3: Upload Video */}
//       <input type="file" accept="video/*" onChange={(e) => setVideo(e.target.files[0])} />
//       <button onClick={uploadVideo}>Upload Video</button>
//     </div> </div> </div></div>
//   );
// }

// export default SocialMedia;
// //QETKD-PhapwL4oADoV6QsNfu5NFvR0Hix9w4C0caywJ5ILlGUvuoiPeh7rnp0Auc5FXjF3vpVNDCwj8lllk5Ny4Sid896FF-9PKqb_Mcf4bdBAVaRi2iQMnBVIvNl1a9BkEyXoB2t0L9kN9B_tb53QhH5E9EFsvZqeV8nxcS_Y7oG6w0tXyoTelSBfxYAso22WbcZ2B0mCvorXv5ItENSg*3!5912.va


    // const handleFacebookLogin = () => {
    //     window.FB.login(response => {
    //         if (response.authResponse) {
    //             const { accessToken, userID } = response.authResponse;
    //             console.log("userID",userID);
    //             fetchFacebookPages(accessToken);
    //         } else {
    //             alert("Facebook login failed!");
    //         }
    //     }, { scope: 'pages_show_list,pages_read_engagement,instagram_basic' });
    // };

    // const fetchFacebookPages = async (userAccessToken) => {
    //     try {
    //         const response = await axios.get(`https://graph.facebook.com/v18.0/me/accounts?access_token=${userAccessToken}`);
    //         if (response.data && response.data.data.length > 0) {
    //             const pageAccessToken = response.data.data[0].access_token;
    //             saveToken('facebook', pageAccessToken);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching Facebook pages:', error);
    //     }
    // };

    // const saveToken = async (platform, token) => {
    //     try {
    //         // await axios.post('/api/socialmedia/save-token', { platform, token });
    //         // setConnectedAccounts(prev => ({ ...prev, [platform]: true }));
    //         console.log("fb token:",token)
    //         alert(`${platform} connected successfully!`);
    //     } catch (error) {
    //         console.error('Error saving token:', error);
    //     }
    // };
    //end social media new block code